import { Select, Space } from "antd";

const DEFAULT_SORTING_OPTIONS = [
  {
    label: "Ascending",
    value: "asc",
  },
  {
    label: "Descending",
    value: "desc",
  },
];

interface CustomSharedSortingDropdownProps {
  handleSort?: (value: string) => void;
  sorting?: unknown;
  sortingOptions?: {
    label: string;
    value: string;
  }[];
}

const CustomSharedSortingDropdown = ({
  handleSort = () => {},
  sorting,
  sortingOptions = DEFAULT_SORTING_OPTIONS,
}: CustomSharedSortingDropdownProps) => {
  const sortDir =
    sorting && typeof sorting === "object" && "sortDir" in sorting
      ? String(sorting.sortDir ?? "").toLowerCase()
      : null;

  return (
    <Space wrap>
      <Select
        className="flex items-center "
        placeholder="Sort by"
        variant="outlined"
        onChange={handleSort}
        options={sortingOptions}
        value={sortDir}
      />
    </Space>
  );
};

export default CustomSharedSortingDropdown;
